import React, { FC } from 'react';
import { Paper, PaperProps } from '@material-ui/core';

interface IProps extends PaperProps {
  disableBorder?: boolean;
  padding?: number | string;
  rounded?: boolean;
}

const PaddedPaper: FC<IProps> = ({ children, disableBorder, padding, rounded, ...rest }) => {
  const borderStyle = disableBorder ? { border: 0 } : {};
  const roundedStyle = rounded ? { borderRadius: 16 } : {};

  return (
    <Paper style={{ padding, ...borderStyle, ...roundedStyle }} {...rest}>
      {children}
    </Paper>
  );
};

PaddedPaper.defaultProps = {
  disableBorder: false,
  padding: 16,
  rounded: false,
};

export default PaddedPaper;
